import { useFormContext } from "react-hook-form";
import { ItsButtonSearchField } from "@/components/its-lookup";

function LagatItsLookup() {
  const { setValue } = useFormContext();

  return (
    <ItsButtonSearchField
      source="itsNo"
      label="ITS No"
      isRequired
      fullWidth
      showNoResult={false}
      onFound={(record) => {
        setValue("itsNo", record.ITS_ID);
        setValue("name", record.Full_Name);
      }}
    />
  );
}

export default LagatItsLookup;
